/* Package JSON Import will be here */
import React, { Component } from "react";
import { getTranslate } from "react-localize-redux";
import { connect } from "react-redux";
import { Row, Col, Steps, Spin, Image } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import mpLogoBig from "assets/img/mp-logo-big.png";
import welcomeImage from "assets/img/welcomeImage.png";
import Login from "containers/session_jnj/Login";
import AddToHomeScreen from "components/reusable/AddToHomeScreen";
import AppVersion from "components/reusable/AppVersion";
import DocumentPageTitle from "components/reusable/DocumentPageTitle";
import SelectWholeSalerModal from "components/wholesalers/SelectWholeSalerModal";
import { Spinner } from "components/Spinner";
import IvyLogoWithoutName from "assets/img/ivy/ivy-logo-without-name.png";
/* Project Import will be here */

/* Styles will be here */
import "./style/indexStyle.css";
/* Styles will be here */

/* Const,Let & Var will be here */
const { Step } = Steps;
/* Const,Let & Var will be here */

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowAddToHomeScreen: true
    };
  }

  customDot = (dot, { status, index }) => (
    <React.Fragment>
      {index === 0 ? <i className="fa fa-check-circle-o stepper-tick fa-2x" aria-hidden="true"></i> : <Spin className="stepper-spin" />}
    </React.Fragment>
  );

  cancelAddToHomeScreen = () => {
    this.setState({ isShowAddToHomeScreen: false });
  };

  renderComp = () => {
    const { translate, appSettings, session, wholesalers } = this.props;

    if (wholesalers.isLoading) {
      return (
        <div id="overlay" className="mt-5">
          <Spinner message={translate("common.loading.appLoading")} />
        </div>
      )
    }
    else if (wholesalers.isShowDistributorSelectionModal) {
      return (
        <SelectWholeSalerModal isShowDistributorSelectionModal={wholesalers.isShowDistributorSelectionModal} />
      )
    }
    else {
      return (
        <div className="container pl-0 pr-0 mt-0">
          <Row className="flex-grow-wrap">
            <Col xs={24} sm={24} md={24} lg={14} xl={14} className="grid-col-left">
              {/* Welcome png and client logo images for web and mobile view */}
              {/* Web view welcome png */}
              <div className="text-center mb-2 display-block-web">
                <Image
                  className="product-logo"
                  src={window.logoUrl ? window.logoUrl + 'vectorlogo.png' : welcomeImage}
                  alt={translate("common.imageAlt.vectorLogo")}
                  fallback={welcomeImage}
                  preview={false}
                />
              </div>

              {/* mobile view welcome png or client logo */}
              <div className="text-center display-block-mobile">
                <Image
                  className="product-logo p-4"
                  src={window.logoUrl ? window.logoUrl + 'clientlogo.png' : welcomeImage}
                  alt={translate("common.imageAlt.clientLogo")}
                  fallback={welcomeImage}
                  preview={false}
                />
              </div>
            </Col>

            <Col xs={24} sm={24} md={24} lg={10} xl={10} className="grid-col-right">
              <div className="login-container-width">
                <div className="pb-2">
                  <h5 className="font-bold">{translate("session.signIn.welcomeTo", { appName: window.clientAppName !== "" ? window.clientAppName : translate("common.ivyMarketplace") })}</h5>
                </div>

                {/* Client Logo */}
                <div className="mb-2 text-center display-block-web client-logo">
                  <Image
                    className='p-1'
                    src={window.logoUrl + 'clientlogo.png'}
                    alt={translate("common.imageAlt.clientLogo")}
                    fallback={mpLogoBig}
                    preview={false}
                  />
                </div>

                {/* Show stepper during the retailer onboarding mobile number capturing */}
                {session.userLoginAtFirstTime && !session.isLoginWithPassword &&
                  <Row>
                    <Col span={24}>
                      <Steps size="small" progressDot={this.customDot} current={1} className="mobile-form-stepper">
                        <Step
                          className="user-name-step"
                          title={translate("session.common.username")}
                          description={translate("session.common.numberVerified")}
                        />
                        <Step
                          title={translate("session.common.mobileNumber")}
                          description={translate("session.common.phoneNumberStatus")}
                        />
                      </Steps>
                    </Col>
                  </Row>
                }

                {/* Login form */}
                <div className="p-2 overflow-login-form">
                  <Login />
                </div>

                <div className="footer-login-page">
                  {/* Version Number */}
                  <AppVersion isFromDrawer={false} />

                  {/* Copyrights footer */}
                  <div className="login-copyright-footer font-10">
                    <img className="copyright-footer-img cursor-pointer" src={IvyLogoWithoutName} alt={translate("common.imageAlt.ivyLogo")} />
                    {translate("common.copyrightMessage", { year: new Date().getFullYear() })}
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* Add to home screen */}
          {
            (appSettings.customAddToHomeScreen && window.showAddToHomeScreen) && (
              <AddToHomeScreen
                isShowAddToHomeScreen={this.state.isShowAddToHomeScreen}
                toggleAccount={this.cancelAddToHomeScreen}
              />
            )
          }
        </div>
      )
    }
  }

  render() {
    return (
      <React.Fragment>
        {/* Set page title */}
        <DocumentPageTitle {...this.props} />

        {this.renderComp()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    appSettings: state.appSettings,
    session: state.session,
    wholesalers: state.wholesalers
  };
};

export default connect(mapStateToProps, null)(Index);
